import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTitle from '../../../components/common/page-title/index';
import { getNextAuditSubmission } from '../../../actions/submissions';
import { history } from '../../../store';

class NextAuditSubmission extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getNextAuditSubmission());
  }

  componentDidUpdate(prevProps) {
    const { nextAuditSubmission } = this.props;

    if (prevProps.nextAuditSubmission !== nextAuditSubmission) {
      history.push(`/admin/audit/submissions/${nextAuditSubmission.id}`);
    }
  }

  render() {
    const { errors } = this.props;

    return (
      <div className="container-fluid">
        <PageTitle>Audit Submission</PageTitle>
        <div>
          {errors && errors.length > 0 ? errors[0] : 'Loading...'}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  nextAuditSubmission: state.submissions.next_audit_submission,
  errors: state.submissions.errors
});

export default connect(mapStateToProps)(NextAuditSubmission);



// WEBPACK FOOTER //
// ./src/components/admin/submissions/next-audit-submission.jsx